module.exports = __webpack_public_path__ + "img/planet-type.d7bb4577.svg";